import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changePasswordAPI,
  getAnnouncementAPI,
  getCurrentBetsAPI,
  getExposureTableAPI,
  getUserByIdAPI,
  loginAPI,
} from "../service/AuthService";
import { getUserDataAPI } from "../service/UserService";
import { useQuery } from "react-query";
import LoginPopUp from "./LoginPopUp";
import JSEncrypt from "jsencrypt";
import { Encrypt, PUBLIC_KEY } from "../utils/constants";
import { generateHash } from "../service";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "./Loader";
import moment from "moment";
import TwentyTwentyTeenpatti from "./Rules/2020Teenpatti";
import NoRule from "./Rules/NoRule";
import Baccarat from "./Rules/Baccarat";
import Dt from "./Rules/Dt";
import L7a from "./Rules/l7a";
import Aba from "./Rules/Aba";
import ThirtyTwoCardA from "./Rules/ThirtyTwoCardA";
import TwentyPokerA from "./Rules/TwentyPokerA";
import BaccaratA from "./Rules/BaccaratA";
import OndeDayTp from "./Rules/OndeDayTp";
import DragonTiger from "./Rules/DragonTiger";
import Muflis from "./Rules/Muflis";
import DTLA from "./Rules/DTLA";
import FastDT from "./Rules/FastDT";
import CasinoW from "./Rules/CasinoW";
import CasinoMeter from "./Rules/CasinoMeter";
import TwentyNineBacc from "./Rules/TwentyNineBacc";
import PointTp from "./Rules/PointTp";
import AAA from "./Rules/AAA";
import OneCardMeter from "./Rules/OneCardMeter";
import OneCard20 from "./Rules/OneCard20";
import Trio from "./Rules/Trio";
import AndarBaharC from "./Rules/AndarBaharC";
import Lottery from "../pages/static/Lottery";
import LotteryC from "./Rules/LotteryC";
import ThirtyTwoCardB from "./Rules/ThirtyTwoCardB";

export default function Header() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isMobileBetOpen, setIsMobileBetOpen] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const [announcement, setAnnouncement] = React.useState({});
  const [balanceLoad, setBalanceLoad] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const [showRules, setShowRules] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [oldPassword, setOldPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [selectedBetOpen, setSelectedBetOpen] = useState("");
  const [eventWiseBets, setEventWiseBets] = useState([]);
  const [activeRule, setActiveRule] = useState(false);
  const RulesMap = {
    "20-20 TEENPATTI": "20-20 TEENPATTI",
    VIMAAN: "VIMAAN",
    BACCARAT: "BACCARAT",
    EVOLUTION: "EVOLUTION",
    "20-20 DRAGON TIGER": "20-20 DRAGON TIGER",
    "LUCKY 7 - A": "LUCKY 7 - A",
  };
  const [rules, setRules] = useState([
    {
      name: "20-20 TEENPATTI",
      ui: <TwentyTwentyTeenpatti />,
      isActive: false,
    },
    {
      name: "VIMAAN",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "BACCARAT",
      ui: <Baccarat />,
      isActive: false,
    },
    {
      name: "EVOLUTION",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "20-20 DRAGON TIGER",
      ui: <Dt />,
      isActive: false,
    },
    {
      name: "LUCKY 7 - A",
      ui: <L7a />,
      isActive: false,
    },
    {
      name: "ANDAR BAHAR - A",
      ui: <Aba />,
      isActive: false,
    },
    {
      name: "32 CARDS - A",
      ui: <ThirtyTwoCardA />,
      isActive: false,
    },
    {
      name: "EZUGI",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "20-20 POKER - A",
      ui: <TwentyPokerA />,
      isActive: false,
    },
    {
      name: "BACCARAT - A",
      ui: <BaccaratA />,
      isActive: false,
    },
    {
      name: "1DAY TEEN PATTI",
      ui: <OndeDayTp />,
      isActive: false,
    },
    {
      name: "DRAGON TIGER",
      ui: <DragonTiger />,
      isActive: false,
    },
    {
      name: "FAST LUCKY - 7",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "1 DAY DRAGON TIGER",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "MULTIS TEEN PATTI",
      ui: <Muflis />,
      isActive: false,
    },
    {
      name: "DTL - A",
      ui: <DTLA />,
      isActive: false,
    },
    {
      name: "FAST DRAGON TIGER",
      ui: <FastDT />,
      isActive: false,
    },
    {
      name: "CASINO WAR",
      ui: <CasinoW />,
      isActive: false,
    },
    {
      name: "CASINO METER",
      ui: <CasinoMeter />,
      isActive: false,
    },
    {
      name: "29 CARD BACCARAT",
      ui: <TwentyNineBacc />,
      isActive: false,
    },
    {
      name: "INSTANT WORLD",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "1 DAY BACCARAT",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "BALLOON",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "POINT TEEN PATTI",
      ui: <PointTp />,
      isActive: false,
    },
    {
      name: "JOKER TEEN PATTI",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "HEADS & TAILS",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "DREAM CATCHER",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "LUCKY 0 TO 9",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "AMAR AKBAR ANTHONY",
      ui: <AAA />,
      isActive: false,
    },
    {
      name: "3 CARD JUDGEMENT - A",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "1 CARD METER",
      ui: <OneCardMeter />,
      isActive: false,
    },
    {
      name: "1 CARD 20-20",
      ui: <OneCard20 />,
      isActive: false,
    },
    {
      name: "TRIO",
      ui: <Trio />,
      isActive: false,
    },
    {
      name: "ANDAR BAHAR - C",
      ui: <AndarBaharC />,
      isActive: false,
    },
    {
      name: "LOTTERY",
      ui: <LotteryC />,
      isActive: false,
    },
    {
      name: "20-20 POKER - B",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "DTL TEENPATTI",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "INA MINA DIKA",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "LUCKY 7 - B",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "BOLLYWOOD CASINO",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "20-20 CARD RACE",
      ui: <NoRule />,
      isActive: false,
    },
    {
      name: "BACCARAT - C",
      ui: <OneCard20 />,
      isActive: false,
    },
    {
      name: "32 CARDS - B",
      ui: <ThirtyTwoCardB />,
      isActive: false,
    },
    {
      name: "KBC",
      ui: <NoRule />,
      isActive: false,
    },
  ]);
  const handleChangePassword = async () => {
    if (newPassword === "" || confirmPassword === "" || oldPassword === "") {
      toast.error("Please fill all the fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Password and confirm password does not match");
      return;
    }
    if (newPassword === oldPassword) {
      toast.error("New password and old password cannot be same");
      return;
    }

    var { data, code, message, response, error } = await changePasswordAPI(
      {
        newPassword: Encrypt(newPassword),
        password: Encrypt(oldPassword),
        resetRequired: false,
        uid: userData.id,
      },
      userData.token
    );
    if (code === 200) {
      toast.success("Password changed successfully");
      dispatch({
        type: "accountData/logOut",
        payload: {},
      });
      dispatch({
        type: "gameData/logOut",
        payload: {},
      });
    } else {
      toast.error("Wrong password");
    }
  };
  const getAnnouncement = async () => {
    const { response } = await getAnnouncementAPI();
    setAnnouncement(response);
  };
  const getUserData = async () => {
    if (userData?.token) {
      try {
        var { response, code } = await getUserDataAPI(userData.id);
        if (code === 200) {
          dispatch({
            type: "accountData/setUserProfile",
            payload: response,
          });
        } else {
          dispatch({
            type: "gameData/logOut",
            payload: {},
          });
        }
      } catch (e) {
        dispatch({
          type: "accountData/logOut",
          payload: {},
        });

        localStorage.clear();
        localStorage.removeItem("user");
        localStorage.removeItem("state");
        navigate("/");
        window.location.reload();
      }
    }
  };
  const fetchProfileQuery = useQuery("profile", getUserData, {});
  const logout = () => {
    dispatch({
      type: "accountData/logOut",
      payload: {},
    });

    localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("state");
    navigate("/");
    window.location.reload();
  };
  const [exposureTable, setExposureTable] = useState([]);
  useEffect(() => {
    if (userData?.token) {
      getExposureTableAPI().then((res) => {
        setExposureTable(res.response);
      });
      getAnnouncement();
      let interval;
      interval = setInterval(() => {
        fetchProfileQuery.refetch();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [userData?.token]);
  const counter = localStorage.getItem("counter");
  const login = async (userName, password, isDemo = false) => {
    setLoading(true);
    let encryptedPassword = new JSEncrypt();
    encryptedPassword.setPublicKey(PUBLIC_KEY);
    encryptedPassword = encryptedPassword.encrypt(password);
    setLoading(true);
    let fingerprint = await generateHash();
    localStorage.setItem("fingerprint", fingerprint);
    var { data, code, message, response, error } = await loginAPI(
      userName,
      encryptedPassword,
      isDemo
    );

    if (code == 200) {
      setLoading(false);
      toast.success("Login Success");
      /*  if (counter == 1) {
        localStorage.removeItem("counter");
      } else { */
      localStorage.setItem("counter", 1);
      /* } */
      dispatch({
        type: "accountData/setUserData",
        payload: response,
      });
      dispatch({
        type: "accountData/setLoginPopSate",
        payload: false,
      });
      dispatch({
        type: "accountData/setChangePopSate",
        payload: response.resetRequired,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (code == 500) {
      toast.error(response);
      setLoading(false);
    } else if (code == 403) {
      toast.error(response?.description);
      setLoading(false);
    } else if (code == 401) {
      toast.error(response);
      setLoading(false);
    } else {
      toast.error("Something went wrong or Account is not active");
      setLoading(false);
    }
    setLoading(false);
  };
  const getBetHistory = async () => {
    const { response } = await getExposureTableAPI();
    setExposureTable(response);
  };
  const [payload, setPayload] = React.useState({
    betStatus: "MATCHED",
    betType: "ALL",
    pageNumber: 0,
    pageSize: 1000,
    search: "",
    sports: true,
  });
  const [uniqueEvents, setUniqueEvents] = React.useState([]);
  const [selectedEvent, setSelectedEvent] = React.useState(null);
  const getCurrentBets = async () => {
    const { response } = await getCurrentBetsAPI(payload);
    setData(response?.unsettledBets?.content);
    let uniqueEvents = Array.from(
      new Set(response?.unsettledBets?.content.map((item) => item.event_name))
    );
    setUniqueEvents(uniqueEvents);
  };
  const [betInfo, setBetInfo] = React.useState(null);

  React.useEffect(() => {
    if (userData?.token) getCurrentBets();
  }, [selectedBetOpen]);
  return (
    <>
      {userData?.token && userData?.resetRequired && (
        <div
          _ngcontent-ng-c3807070604=""
          id="changePasswordModal"
          tabIndex={-1}
          aria-labelledby="changePasswordModalLabal"
          aria-hidden="true"
          style={{ display: "block" }}
          className="modal fade show"
        >
          <div _ngcontent-ng-c3807070604="" className="modal-dialog">
            <div _ngcontent-ng-c3807070604="" className="modal-content">
              <div
                _ngcontent-ng-c3807070604=""
                className="modal-header account-detail-head"
              >
                <h5 _ngcontent-ng-c3807070604="" className="modal-title">
                  Change Password
                </h5>
                <button
                  _ngcontent-ng-c3807070604=""
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="close"
                >
                  <span _ngcontent-ng-c3807070604="" aria-hidden="true">
                    ×
                  </span>
                </button>
              </div>
              <div
                _ngcontent-ng-c3807070604=""
                noValidate=""
                className="ng-untouched ng-pristine ng-invalid"
              >
                <div _ngcontent-ng-c3807070604="" className="modal-body">
                  <div _ngcontent-ng-c3807070604="" className="row">
                    <div _ngcontent-ng-c3807070604="" className="col-md-6">
                      <div _ngcontent-ng-c3807070604="" className="form-group">
                        <label
                          _ngcontent-ng-c3807070604=""
                          htmlFor="oldPassword3"
                        >
                          Old Password{" "}
                          <span
                            _ngcontent-ng-c3807070604=""
                            className="asterisk_input"
                          />
                        </label>
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="d-flex align-items-center position-relative"
                        >
                          <input
                            _ngcontent-ng-c3807070604=""
                            formcontrolname="MasterPassword"
                            id="oldPassword3"
                            name="oldPassword3"
                            required=""
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            className="form-control ng-untouched ng-pristine ng-invalid"
                            type={"password"}
                          />
                          <div
                            _ngcontent-ng-c3807070604=""
                            className="input-group-append"
                          >
                            <button
                              onClick={handleChangePassword}
                              _ngcontent-ng-c3807070604=""
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{ border: "none", zIndex: 999 }}
                            >
                              <i
                                _ngcontent-ng-c3807070604=""
                                className="fa fa-eye-slash"
                              />
                            </button>
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </div>
                    <div _ngcontent-ng-c3807070604="" className="col-md-6">
                      <div _ngcontent-ng-c3807070604="" className="form-group">
                        <label
                          _ngcontent-ng-c3807070604=""
                          htmlFor="newPassword"
                        >
                          New Password{" "}
                          <span
                            _ngcontent-ng-c3807070604=""
                            className="asterisk_input"
                          />
                        </label>
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="d-flex align-items-center position-relative"
                        >
                          <input
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            _ngcontent-ng-c3807070604=""
                            id="newPassword"
                            formcontrolname="password"
                            name="password"
                            required=""
                            autoComplete="off"
                            maxLength={20}
                            className=" form-control ng-untouched ng-pristine ng-invalid"
                            type="password"
                          />
                          <div
                            _ngcontent-ng-c3807070604=""
                            className="input-group-append"
                          >
                            <button
                              _ngcontent-ng-c3807070604=""
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{ border: "none", zIndex: 999 }}
                            >
                              <i
                                _ngcontent-ng-c3807070604=""
                                className="fa fa-eye-slash"
                              />
                            </button>
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </div>
                    <div _ngcontent-ng-c3807070604="" className="col-md-6">
                      <div _ngcontent-ng-c3807070604="" className="form-group">
                        <label
                          _ngcontent-ng-c3807070604=""
                          htmlFor="confirmPassword"
                        >
                          Confirm Password{" "}
                          <span
                            _ngcontent-ng-c3807070604=""
                            className="asterisk_input"
                          />
                        </label>
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="d-flex align-items-center position-relative"
                        >
                          <input
                            _ngcontent-ng-c3807070604=""
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            formcontrolname="confirmPassword"
                            maxLength={20}
                            name="confirmpassword"
                            required=""
                            className="form-control ng-untouched ng-pristine ng-invalid"
                            type="password"
                          />
                          <div
                            _ngcontent-ng-c3807070604=""
                            className="input-group-append"
                          >
                            <button
                              _ngcontent-ng-c3807070604=""
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{ border: "none", zIndex: 999 }}
                            >
                              <i
                                _ngcontent-ng-c3807070604=""
                                className="fa fa-eye-slash"
                              />
                            </button>
                          </div>
                        </div>
                        {/**/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div _ngcontent-ng-c3807070604="" className="modal-footer">
                <button
                  _ngcontent-ng-c3807070604=""
                  className="btn btn-primary"
                  onClick={handleChangePassword}
                  disabled=""
                >
                  Confirm
                </button>
                <button
                  _ngcontent-ng-c3807070604=""
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="btn btn-secondary"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
      {loginOpen && (
        <LoginPopUp
          login={login}
          isLoginPopUpOpen={loginOpen}
          setIsLoginPopUpOpen={setLoginOpen}
          isLoading={loading}
          setLoading={setLoading}
        />
      )}
      <>
        <div
          _ngcontent-ng-c1893399002=""
          className="headerDesktop hideMobileHeader"
          _nghost-ng-c1591630683=""
        >
          {isMobileBetOpen && (
            <app-side-nav-bets
              _ngcontent-ng-c1591630683=""
              _nghost-ng-c2125031810=""
            >
              <div _ngcontent-ng-c2125031810="" className="left-bar-container">
                <div _ngcontent-ng-c2125031810="" className="left-bar">
                  <div
                    _ngcontent-ng-c2125031810=""
                    data-simplebar=""
                    className="h-100"
                  >
                    <div
                      _ngcontent-ng-c2125031810=""
                      className="tab-content pt-0"
                    >
                      <div
                        _ngcontent-ng-c2125031810=""
                        id="up-tab"
                        role="tabpanel"
                        className="tab-pane active"
                      >
                        <div
                          _ngcontent-ng-c2125031810=""
                          className="user-menus"
                        >
                          <div
                            _ngcontent-ng-c2125031810=""
                            className="openBetHeader"
                          >
                            <strong _ngcontent-ng-c2125031810="">
                              Open Bets
                            </strong>
                            <button
                              _ngcontent-ng-c2125031810=""
                              type="button"
                              onClick={() =>
                                setIsMobileBetOpen(!isMobileBetOpen)
                              }
                              className="close show-xs cls-openbet"
                            >
                              <span
                                _ngcontent-ng-c2125031810=""
                                aria-hidden="true"
                              >
                                ×
                              </span>
                            </button>
                          </div>
                          <div
                            _ngcontent-ng-c2125031810=""
                            className="outer-mobile-menu-con"
                          >
                            {uniqueEvents?.map((item) => (
                              <div
                                _ngcontent-ng-c2125031810=""
                                className="mobile-menu-con ng-star-inserted"
                              >
                                <div
                                  _ngcontent-ng-c2125031810=""
                                  onClick={() => {
                                    if (selectedBetOpen === item) {
                                      setSelectedBetOpen(null);
                                    } else {
                                      setSelectedBetOpen(item);
                                    }
                                  }}
                                  className="mobile-menu-single-betslip"
                                >
                                  <a
                                    _ngcontent-ng-c2125031810=""
                                    className={`nav-link nav-dropdown-toggl unitycss-46Nkf ${
                                      selectedBetOpen === item && "activesport"
                                    }`}
                                  >
                                    <span
                                      _ngcontent-ng-c2125031810=""
                                      className="bet-marketname"
                                    >
                                      {item}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            ))}
                            {/**/}
                            {selectedBetOpen && (
                              <nav
                                _ngcontent-ng-c2125031810=""
                                className="all-sports-list ng-star-inserted"
                              >
                                <div
                                  _ngcontent-ng-c2125031810=""
                                  className="content-534"
                                >
                                  <div
                                    _ngcontent-ng-c2125031810=""
                                    className="act-16a tab-ltq"
                                  >
                                    <div
                                      _ngcontent-ng-c2125031810=""
                                      id="dplql"
                                      name="txn"
                                      className="list-5fh"
                                    >
                                      <ul
                                        _ngcontent-ng-c2125031810=""
                                        className="matched-nav"
                                      >
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="nav-item-match text-center border-top"
                                        >
                                          <a
                                            _ngcontent-ng-c2125031810=""
                                            className="match-nav-link active fw-bold"
                                          >
                                            <span _ngcontent-ng-c2125031810="">
                                              Matched
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                      <ul
                                        _ngcontent-ng-c2125031810=""
                                        id="bac-xxb"
                                        className="matched-826 unity-ul-d78"
                                      >
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-fpg"
                                        >
                                          Back (Bet For)
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-1ie"
                                        >
                                          Odds
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-mlt"
                                        >
                                          Stake
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-wcg"
                                        >
                                          Profit
                                        </li>
                                      </ul>
                                      {data
                                        ?.filter(
                                          (item) =>
                                            item?.event_name ==
                                              selectedBetOpen &&
                                            (item?.back_rate || item?.back_run)
                                        )
                                        ?.map((item) => (
                                          <dl
                                            _ngcontent-ng-c2125031810=""
                                            id="txn-ley"
                                            className="slip-3ga ng-star-inserted"
                                            style={
                                              betInfo
                                                ? {
                                                    height: "50px",
                                                  }
                                                : {}
                                            }
                                          >
                                            {betInfo && (
                                              <dd
                                                _ngcontent-ng-c2125031810=""
                                                id="bet-yq1"
                                                class="ref-epq ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-ng-c2125031810=""
                                                  id="bet-bjr"
                                                >
                                                  Ref:{" "}
                                                </span>
                                                <span
                                                  _ngcontent-ng-c2125031810=""
                                                  id="pla-fpm"
                                                >
                                                  {moment(
                                                    item?.created_date + "Z"
                                                  ).format(
                                                    "DD-MM-YYYY HH:mm:ss"
                                                  )}
                                                </span>
                                              </dd>
                                            )}
                                            <dt _ngcontent-ng-c2125031810="">
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="slip-ys5 ng-star-inserted"
                                              >
                                                Back
                                              </span>
                                              {/**/}
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="short-nbw ng-star-inserted"
                                              >
                                                {item?.market_name}
                                              </span>
                                              {/**/}
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                id="mar-l2h"
                                                className="marketNameEclispes ng-star-inserted"
                                              >
                                                {item?.runner_name}
                                              </span>
                                              {/**/}
                                            </dt>
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="pri-a35"
                                              className="col-1ie ng-star-inserted"
                                            >
                                              {item?.back_rate}
                                              {item?.back_rate && "/"}
                                              {item?.back_run}

                                              {/**/}
                                            </dd>
                                            {/**/}
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="siz-lp2"
                                              title="$10"
                                              className="col-mlt ng-star-inserted"
                                            >
                                              {item?.amount}
                                            </dd>
                                            {/**/}
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="pro-l8k"
                                              className="col-wcg ng-star-inserted"
                                            >
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="p-0"
                                              >
                                                {item?.profit}
                                              </span>
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="p-0"
                                              >
                                                {" "}
                                                (-{item?.loss}){" "}
                                              </span>
                                            </dd>
                                            {/**/}
                                          </dl>
                                        ))}
                                      {/**/}
                                      {/**/}
                                      {/**/}
                                      <ul
                                        _ngcontent-ng-c2125031810=""
                                        id="lay-zc9"
                                        className="matched-826 unity-ul-d78"
                                      >
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-fpg"
                                        >
                                          Lay (Bet Against)
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-1ie"
                                        >
                                          Odds
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-mlt"
                                        >
                                          Stake
                                        </li>
                                        <li
                                          _ngcontent-ng-c2125031810=""
                                          className="col-wcg"
                                        >
                                          Liability
                                        </li>
                                      </ul>
                                      {data
                                        ?.filter(
                                          (item) =>
                                            item?.event_name ==
                                              selectedBetOpen &&
                                            (item?.lay_rate || item?.lay_run)
                                        )
                                        ?.map((item) => (
                                          <dl
                                            _ngcontent-ng-c2125031810=""
                                            id="txn-ley"
                                            className="slip-y8o"
                                            style={
                                              betInfo
                                                ? {
                                                    height: "50px",
                                                  }
                                                : {}
                                            }
                                          >
                                            {betInfo && (
                                              <dd
                                                _ngcontent-ng-c2125031810=""
                                                id="bet-yq1"
                                                class="ref-epq ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-ng-c2125031810=""
                                                  id="bet-bjr"
                                                >
                                                  Ref:{" "}
                                                </span>
                                                <span
                                                  _ngcontent-ng-c2125031810=""
                                                  id="pla-fpm"
                                                >
                                                  {moment(
                                                    item?.created_date + "Z"
                                                  ).format(
                                                    "DD-MM-YYYY HH:mm:ss"
                                                  )}
                                                </span>
                                              </dd>
                                            )}
                                            <dt _ngcontent-ng-c2125031810="">
                                              {/**/}
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="slip-ys5"
                                              >
                                                Lay
                                              </span>
                                              {/**/}
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="short-nbw"
                                              >
                                                {item?.market_name}
                                              </span>
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                id="mar-l2h"
                                                className="marketNameEclispes"
                                              >
                                                {item?.runner_name}
                                              </span>
                                            </dt>
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="pri-a35"
                                              className="col-1ie"
                                            >
                                              {item?.lay_rate}
                                              {item?.lay_rate && "/"}
                                              {item?.lay_run}
                                            </dd>
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="siz-lp2"
                                              title="$10"
                                              className="col-mlt"
                                            >
                                              {item?.amount}
                                            </dd>
                                            <dd
                                              _ngcontent-ng-c2125031810=""
                                              id="pro-l8k"
                                              className="col-wcg ng-star-inserted"
                                            >
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="p-0"
                                              >
                                                {item?.profit}
                                              </span>
                                              <span
                                                _ngcontent-ng-c2125031810=""
                                                className="p-0"
                                              >
                                                {" "}
                                                (-{item?.loss}){" "}
                                              </span>
                                            </dd>
                                          </dl>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-ng-c2125031810=""
                                  className="btn-gad"
                                >
                                  <ul
                                    _ngcontent-ng-c2125031810=""
                                    className="option-g3c unity-ul-d78"
                                  >
                                    <li _ngcontent-ng-c2125031810="">
                                      <input
                                        onClick={() => setBetInfo(!betInfo)}
                                        _ngcontent-ng-c2125031810=""
                                        id="ope-23t"
                                        name="openOption"
                                        type="checkbox"
                                      />
                                      <label
                                        _ngcontent-ng-c2125031810=""
                                        htmlFor="showBetInfo"
                                      >
                                        Bet Info
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                              </nav>
                            )}
                            {/**/}
                          </div>

                          <div
                            _ngcontent-ng-c2125031810=""
                            className="scrollSlip"
                          >
                            <div
                              _ngcontent-ng-c2125031810=""
                              id="txnList"
                              name="txn"
                              className="slip-list"
                            >
                              {}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </app-side-nav-bets>
          )}
          {showRules && (
            <app-rules-list
              _ngcontent-ng-c1888221295=""
              _nghost-ng-c841324608=""
            >
              <div _ngcontent-ng-c841324608="" className="left-bar-container">
                <div _ngcontent-ng-c841324608="" className="left-bar">
                  <div
                    _ngcontent-ng-c841324608=""
                    data-simplebar=""
                    className="h-100"
                  >
                    <div
                      _ngcontent-ng-c841324608=""
                      className="tab-content pt-0"
                    >
                      <div
                        _ngcontent-ng-c841324608=""
                        id="up-tab"
                        role="tabpanel"
                        className="tab-pane active"
                      >
                        <div
                          _ngcontent-ng-c841324608=""
                          className="user-menus"
                          style={{ background: "black" }}
                        >
                          <div
                            _ngcontent-ng-c841324608=""
                            className="openBetHeader"
                          >
                            <strong _ngcontent-ng-c841324608="">
                              Rules List
                            </strong>
                            <button
                              _ngcontent-ng-c841324608=""
                              type="button"
                              onClick={() => setShowRules(!showRules)}
                              className="close show-xs cls-openbet"
                            >
                              <span
                                _ngcontent-ng-c841324608=""
                                aria-hidden="true"
                              >
                                ×
                              </span>
                            </button>
                          </div>
                          <ul
                            _ngcontent-ng-c841324608=""
                            className="ulScrollRule"
                          >
                            {rules.map((item) => (
                              <>
                                <li _ngcontent-ng-c841324608="" className="m-2">
                                  <a
                                    _ngcontent-ng-c841324608=""
                                    onClick={() => {
                                      if (activeRule?.name === item?.name) {
                                        setActiveRule(null);
                                      } else {
                                        setActiveRule(item);
                                      }
                                    }}
                                    className="waves-effect waves-light sideNavCheck d-flex align-items-center justify-content-between"
                                  >
                                    {" "}
                                    {item?.name}
                                    <i
                                      _ngcontent-ng-c841324608=""
                                      className="fa"
                                      style={{ marginRight: 12 }}
                                    />
                                  </a>
                                </li>
                                {activeRule?.name === item?.name &&
                                  activeRule?.ui}
                              </>
                            ))}

                            <div
                              _ngcontent-ng-c841324608=""
                              style={{ height: 100 }}
                            />
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </app-rules-list>
          )}
          <div _ngcontent-ng-c1591630683="" className="site-header app-header">
            {userData?.token ? (
              <div
                _ngcontent-ng-c1591630683=""
                className="after-login ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1591630683=""
                  className="d-flex align-items-center"
                >
                  {location.pathname.includes("/casino") ? (
                    <a
                      onClick={() => {
                        setShowRules(!showRules);
                      }}
                      _ngcontent-ng-c1888221295=""
                      class="navbar-brand hidden-lg"
                    >
                      <span _ngcontent-ng-c1888221295="" class="open_bets">
                        {" "}
                        Rules{" "}
                      </span>
                    </a>
                  ) : (
                    <a
                      _ngcontent-ng-c1591630683=""
                      title="Setting"
                      onClick={() => {
                        getBetHistory();
                        toast.success("Data Refreshed");
                        setIsMobileBetOpen(!isMobileBetOpen);
                      }}
                      className="open-bets"
                    >
                      <svg
                        _ngcontent-ng-c1591630683=""
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                      >
                        <path
                          _ngcontent-ng-c1591630683=""
                          fill="currentColor"
                          fillRule="nonzero"
                          d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"
                        />
                      </svg>{" "}
                      &nbsp;Bets{" "}
                    </a>
                  )}
                  {location.pathname.includes("/casino") && (
                    <a
                      _ngcontent-ng-c1888221295=""
                      routerlink="/home"
                      class="gameLobby"
                      href="/home"
                    >
                      {" "}
                      Gaming Lobby{" "}
                    </a>
                  )}
                </div>
                <div
                  _ngcontent-ng-c1591630683=""
                  className="hideMobileHeader"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    _ngcontent-ng-c1591630683=""
                    href="/"
                    alt="logo"
                    className="site-logo-after ms-1"
                    tabIndex={0}
                    src="/assets/images/logo.png"
                  />

                  <div _ngcontent-ng-c1591630683="" className="searchBox"></div>
                </div>
                <div _ngcontent-ng-c1591630683="" className="demo">
                  <div
                    _ngcontent-ng-c1591630683=""
                    className="Myaccount-after-login"
                  >
                    <div _ngcontent-ng-c1591630683="" className="user-blnc">
                      {balanceLoad ? (
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="loadingBalance ng-star-inserted"
                        >
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                          <span _ngcontent-ng-c1591630683="" />
                        </div>
                      ) : (
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="balance ng-star-inserted"
                          style={{ textAlign: "center" }}
                        >
                          <span
                            _ngcontent-ng-c1591630683=""
                            className="pti-ic"
                            style={{ display: "block" }}
                          >
                            {" "}
                            Main{" "}
                            <strong _ngcontent-ng-c1591630683="">
                              PTI{" "}
                              <span
                                _ngcontent-ng-c1591630683=""
                                className="userTotalBalance"
                              >
                                {" "}
                                {userData?.balance + userData?.liability}
                              </span>
                            </strong>
                          </span>
                          <span
                            _ngcontent-ng-c1591630683=""
                            className="exp-topcount"
                            style={{ marginLeft: 20 }}
                          >
                            Exposure{" "}
                            <a
                              _ngcontent-ng-c1591630683=""
                              data-bs-toggle="modal"
                              data-bs-target="#exposureModals"
                              className="mouse-pointer"
                            >
                              <strong _ngcontent-ng-c1591630683="">
                                (
                                <span
                                  _ngcontent-ng-c1591630683=""
                                  className="exp-red userTotalExposure"
                                >
                                  {Math.abs(userData?.liability)}
                                </span>
                                ){" "}
                              </strong>
                            </a>
                          </span>
                        </div>
                      )}
                    </div>
                    <div
                      _ngcontent-ng-c1591630683=""
                      className="login-refresh-MAcnt-btn"
                    >
                      <span
                        _ngcontent-ng-c1591630683=""
                        className="head-refresh"
                      >
                        <a
                          _ngcontent-ng-c1591630683=""
                          id="menuRefresh"
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                      <a
                        _ngcontent-ng-c1591630683=""
                        href="javascript:;"
                        title="Setting"
                        className="a-referesh"
                      >
                        <img
                          _ngcontent-ng-c1591630683=""
                          src="../../../assets/reload-bg-transparant.gif"
                        />
                      </a>
                    </div>
                    <div
                      _ngcontent-ng-c1591630683=""
                      placement="bottom right"
                      className="myaccnt hidden-xs"
                    >
                      <a
                        _ngcontent-ng-c1591630683=""
                        aria-haspopup="true"
                        data-bs-toggle="dropdown"
                        id="accountPopup"
                        role="button"
                        aria-expanded="false"
                        className="nav-link My-acc-font"
                        style={{ cursor: "pointer" }}
                      >
                        My Account
                      </a>
                      <ul
                        _ngcontent-ng-c1591630683=""
                        className="dropdown-menu"
                      >
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="dropdown-header text-left"
                        >
                          <strong _ngcontent-ng-c1591630683="">exchange</strong>
                        </div>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/myprofile"
                          className="dropdown-item"
                          href="/myprofile"
                        >
                          My Profile
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/rolling-commission"
                          className="dropdown-item"
                          href="/rolling-commission"
                        >
                          Rolling Commission
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/account-statement"
                          className="dropdown-item"
                          href="/account-statement"
                        >
                          Account Statement
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/bet-history"
                          className="dropdown-item"
                          href="/bet-history"
                        >
                          Bets History
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/profit-loss"
                          className="dropdown-item"
                          href="/profit-loss"
                        >
                          Profit &amp; Loss
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/password-history"
                          className="dropdown-item"
                          href="/password-history"
                        >
                          Password History
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/activity-log"
                          className="dropdown-item"
                          href="/activity-log"
                        >
                          Activity Log
                        </a>
                        <a
                          _ngcontent-ng-c1591630683=""
                          className="dropdown-item drp-logout"
                        >
                          <button
                            onClick={logout}
                            _ngcontent-ng-c1591630683=""
                            className="btn btn-primary logout-btn"
                          >
                            LOGOUT{" "}
                            <i
                              _ngcontent-ng-c1591630683=""
                              aria-hidden="true"
                              className="fa fa-sign-out-alt ms-2"
                            />
                          </button>
                        </a>
                      </ul>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c1591630683=""
                    className="reload-banking-btns"
                  >
                    <div _ngcontent-ng-c1591630683="" className="bet-refresh">
                      <a
                        _ngcontent-ng-c1591630683=""
                        title="refesh"
                        className="a-referesh"
                        onClick={() => {
                          setBalanceLoad(true);
                          getUserData().then(() => {
                            setBalanceLoad(false);
                          });
                        }}
                      >
                        <svg
                          _ngcontent-ng-c1591630683=""
                          width={20}
                          height={20}
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <defs _ngcontent-ng-c1591630683="">
                            <path
                              _ngcontent-ng-c1591630683=""
                              fill="currentColor"
                              d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                              id="b"
                            />
                            <filter
                              _ngcontent-ng-c1591630683=""
                              x="-2.9%"
                              y="-3.1%"
                              width="105.7%"
                              height="106.3%"
                              filterUnits="objectBoundingBox"
                              id="a"
                            >
                              <feOffset
                                _ngcontent-ng-c1591630683=""
                                dy={2}
                                in="SourceAlpha"
                                result="shadowOffsetInner1"
                              />
                              <feComposite
                                _ngcontent-ng-c1591630683=""
                                in="shadowOffsetInner1"
                                in2="SourceAlpha"
                                operator="arithmetic"
                                k2={-1}
                                k3={1}
                                result="shadowInnerInner1"
                              />
                              <feColorMatrix
                                _ngcontent-ng-c1591630683=""
                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                                in="shadowInnerInner1"
                              />
                            </filter>
                          </defs>
                          <g
                            _ngcontent-ng-c1591630683=""
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              _ngcontent-ng-c1591630683=""
                              transform="translate(-7 -6)"
                            >
                              <use
                                _ngcontent-ng-c1591630683=""
                                fill="#000"
                                filter="url(#a)"
                                xlinkHref="#b"
                              />
                              <path
                                _ngcontent-ng-c1591630683=""
                                stroke="#BC8C17"
                                d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                                strokeLinejoin="square"
                              />
                            </g>
                            <path
                              _ngcontent-ng-c1591630683=""
                              d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                              fill="currentColor"
                            />
                          </g>
                        </svg>
                      </a>
                    </div>
                    {userData?.token && (
                      <div
                        _ngcontent-ng-c1591630683=""
                        className="bet-setting setting-ic ml-2 mr-1"
                      >
                        <a
                          _ngcontent-ng-c1591630683=""
                          routerlink="/settings"
                          title="Setting"
                          className="a-setting a-referesh"
                          href="/settings"
                        >
                          <svg
                            _ngcontent-ng-c1591630683=""
                            width={20}
                            height={20}
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <defs _ngcontent-ng-c1591630683="">
                              <path
                                _ngcontent-ng-c1591630683=""
                                d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                                id="b"
                              />
                              <filter
                                _ngcontent-ng-c1591630683=""
                                x="-2.9%"
                                y="-3.1%"
                                width="105.7%"
                                height="106.3%"
                                filterUnits="objectBoundingBox"
                                id="a"
                              >
                                <feOffset
                                  _ngcontent-ng-c1591630683=""
                                  dy={2}
                                  in="SourceAlpha"
                                  result="shadowOffsetInner1"
                                />
                                <feComposite
                                  _ngcontent-ng-c1591630683=""
                                  in="shadowOffsetInner1"
                                  in2="SourceAlpha"
                                  operator="arithmetic"
                                  k2={-1}
                                  k3={1}
                                  result="shadowInnerInner1"
                                />
                                <feColorMatrix
                                  _ngcontent-ng-c1591630683=""
                                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                                  in="shadowInnerInner1"
                                />
                              </filter>
                            </defs>
                            <g
                              _ngcontent-ng-c1591630683=""
                              fill="none"
                              fillRule="evenodd"
                            >
                              <g
                                _ngcontent-ng-c1591630683=""
                                transform="translate(-8 -6)"
                              >
                                <use
                                  _ngcontent-ng-c1591630683=""
                                  fill="#000"
                                  filter="url(#a)"
                                  xlinkHref="#b"
                                />
                                <path
                                  _ngcontent-ng-c1591630683=""
                                  stroke="#BC8C17"
                                  d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                                  strokeLinejoin="square"
                                />
                              </g>
                              <path
                                _ngcontent-ng-c1591630683=""
                                d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div _ngcontent-ng-c1591630683="" className="before-login-items">
                <div
                  _ngcontent-ng-c1591630683=""
                  className="site-logo-con"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    _ngcontent-ng-c1591630683=""
                    href="/"
                    alt=""
                    className="site-logo ng-star-inserted"
                    tabIndex={0}
                    src="/assets/images/logo.png"
                  />

                  <div _ngcontent-ng-c1591630683="" className="searchBox"></div>
                </div>
                <div
                  _ngcontent-ng-c1591630683=""
                  className="login-signup-uname-pass"
                >
                  <div
                    _ngcontent-ng-c1591630683=""
                    className="header-uname-pass"
                  >
                    <div
                      _ngcontent-ng-c1591630683=""
                      className="d-flex align-items-center phoneNumberDiv me-2"
                    >
                      <input
                        _ngcontent-ng-c1591630683=""
                        type="text"
                        autofocus=""
                        tabIndex={1}
                        autoComplete="off"
                        onChange={(e) => setUserName(e.target.value)}
                        name="userName"
                        id="userName"
                        placeholder="Username"
                        className="phoneNumberInput ng-untouched ng-pristine ng-valid"
                        style={{ padding: 0, borderRadius: 3, width: "100%" }}
                        maxLength={13}
                      />
                    </div>
                    <input
                      _ngcontent-ng-c1591630683=""
                      type="password"
                      name="passwordformbl"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      className="password form-control me-2 username userPassword ng-untouched ng-pristine ng-valid"
                    />
                  </div>
                  <div _ngcontent-ng-c1591630683="" className="login-signup">
                    <button
                      _ngcontent-ng-c1591630683=""
                      data-bs-toggle="modal"
                      //onClick={() => setLoginOpen(true)}
                      data-bs-target="#ageconfirmationModal"
                      className="btn login me-1"
                    >
                      <b
                        _ngcontent-ng-c1591630683=""
                        style={{ width: 33, height: 18 }}
                      >
                        Login
                      </b>
                      <i
                        _ngcontent-ng-c1591630683=""
                        className="fa fa-sign-in ms-1"
                      />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            _ngcontent-ng-c1591630683=""
            id="ageconfirmationModal"
            tabIndex={-1}
            aria-labelledby="ageconfirmationModal"
            aria-hidden="true"
            className="modal fade"
          >
            <div
              _ngcontent-ng-c1591630683=""
              className="modal-dialog modal-dialog-centered"
            >
              <div _ngcontent-ng-c1591630683="" className="modal-content">
                <div
                  _ngcontent-ng-c1591630683=""
                  className="login-popup-content"
                >
                  <div
                    _ngcontent-ng-c1591630683=""
                    className="modal-body ageconfirmationModalclass"
                  >
                    <div
                      _ngcontent-ng-c1591630683=""
                      className="login-panel-container confirm-container"
                    >
                      <div
                        _ngcontent-ng-c1591630683=""
                        className="confirm-text"
                      >
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="header-popup"
                        >
                          <a
                            _ngcontent-ng-c1591630683=""
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={
                              /*--function--*/ () => {
                                setLoginOpen(false);
                              }
                            }
                            className="ui-link"
                          >
                            <i
                              _ngcontent-ng-c1591630683=""
                              className="fas fa-times"
                            />
                          </a>
                        </div>
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="text1 text-confirm-bold"
                        >
                          Non-Gambling Territories.
                        </div>
                        <hr
                          _ngcontent-ng-c1591630683=""
                          className="confirm-line"
                        />
                        <div _ngcontent-ng-c1591630683="" className="text2">
                          Connecting to our site from non gambling countries, it
                          will be User's responsibility to ensure that their use
                          of the service is lawful.
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c1591630683=""
                        className="confirm-text"
                      >
                        <div
                          _ngcontent-ng-c1591630683=""
                          className="text1 text-confirm-bold"
                        >
                          Underage gambling is prohibited.
                        </div>
                        <hr
                          _ngcontent-ng-c1591630683=""
                          className="confirm-line"
                        />
                        <div _ngcontent-ng-c1591630683="" className="text2">
                          Please confirm if you are{" "}
                          <span _ngcontent-ng-c1591630683="">
                            18 years old and above
                          </span>{" "}
                          as of today.{" "}
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c1591630683=""
                        className="confirm-button"
                      >
                        <button
                          _ngcontent-ng-c1591630683=""
                          onClick={() => setLoginOpen(true)}
                          data-bs-dismiss="modal"
                          className="btn-verification btn-confirm"
                          tabIndex={0}
                        >
                          <span _ngcontent-ng-c1591630683="">Confirm</span>
                        </button>
                        <button
                          _ngcontent-ng-c1591630683=""
                          data-bs-dismiss="modal"
                          className="btn-verification"
                        >
                          <a
                            _ngcontent-ng-c1591630683=""
                            style={{ textDecoration: "none" }}
                          >
                            <span _ngcontent-ng-c1591630683="">Exit</span>
                          </a>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c1591630683=""
            id="exposureModals"
            tabIndex={-1}
            aria-labelledby="exposureModalLabel"
            aria-hidden="true"
            className="modal fade exposureModals"
          >
            <div _ngcontent-ng-c1591630683="" className="modal-dialog modal-md">
              <div _ngcontent-ng-c1591630683="" className="modal-content">
                <div
                  _ngcontent-ng-c1591630683=""
                  className="modal-header exposure-details"
                >
                  <h1
                    _ngcontent-ng-c1591630683=""
                    id="exposureModalLabel"
                    className="modal-title"
                  >
                    Exposure Detail
                  </h1>
                  <button
                    _ngcontent-ng-c1591630683=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    <span _ngcontent-ng-c1591630683="" aria-hidden="true">
                      ×
                    </span>
                  </button>
                </div>
                <div _ngcontent-ng-c1591630683="" className="modal-body">
                  <table
                    _ngcontent-ng-c1591630683=""
                    className="table table-responsive table-bordered"
                  >
                    <thead _ngcontent-ng-c1591630683="">
                      <tr _ngcontent-ng-c1591630683="" className="theme1font">
                        <th
                          _ngcontent-ng-c1591630683=""
                          className="text-center"
                        >
                          Sport Name
                        </th>
                        <th
                          _ngcontent-ng-c1591630683=""
                          className="text-center"
                          style={{ width: "50%" }}
                        >
                          Event Name
                        </th>
                        <th
                          _ngcontent-ng-c1591630683=""
                          className="text-center"
                        >
                          Market Name
                        </th>
                        <th
                          _ngcontent-ng-c1591630683=""
                          className="text-center"
                        >
                          Trade
                        </th>
                      </tr>
                    </thead>
                    {exposureTable && exposureTable.length > 0 && (
                      <tbody _ngcontent-ng-c3537561944="">
                        {exposureTable?.map((item) => (
                          <tr
                            _ngcontent-ng-c3537561944=""
                            className="exposurebody"
                          >
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.eventType}
                            </td>
                            <td
                              onClick={() => {
                                navigate(
                                  `/game/${item?.eventType?.toLowerCase()}/${
                                    item.eventId
                                  }`
                                );
                                //close modal
                                document
                                  .getElementById("exposureModals")
                                  .classList.remove("show");
                                document
                                  .getElementById("exposureModals")
                                  .setAttribute("aria-hidden", "true");
                                document
                                  .getElementById("exposureModals")
                                  .setAttribute("style", "display: none;");
                                document
                                  .getElementsByClassName("modal-backdrop")[0]
                                  .remove();
                              }}
                              style={{
                                color: "blue",
                                fontWeight: "bold",
                              }}
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.eventName}
                            </td>
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.marketName}
                            </td>
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.trade}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                    {exposureTable && exposureTable.length === 0 && (
                      <tfoot
                        _ngcontent-ng-c1591630683=""
                        className="ng-star-inserted"
                      >
                        <tr
                          _ngcontent-ng-c1591630683=""
                          className="exposurebody"
                        >
                          <td
                            _ngcontent-ng-c1591630683=""
                            colSpan={4}
                            className="text-center"
                          >
                            No real-time records found ...
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          _ngcontent-ng-c1893399002=""
          className="headerDesktop hideDekstop"
          _nghost-ng-c3537561944=""
        >
          <div _ngcontent-ng-c3537561944="" className="site-header app-header">
            {userData?.token ? (
              <div _ngcontent-ng-c3537561944="" className="before-login-items">
                <div
                  _ngcontent-ng-c3537561944=""
                  className="site-logo-con"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    _ngcontent-ng-c3537561944=""
                    alt=""
                    href="/"
                    className="site-logo ng-star-inserted"
                    style={{ cursor: "pointer" }}
                    src="/assets/images/logo.png"
                  />
                </div>
                <div
                  _ngcontent-ng-c3537561944=""
                  className="login-signup-uname-pass"
                >
                  <ul
                    _ngcontent-ng-c3537561944=""
                    className="desktopviewButton hideDekstop showDekstop"
                    style={{ position: "relative" }}
                  >
                    <li _ngcontent-ng-c3537561944=""></li>
                    <li
                      _ngcontent-ng-c3537561944=""
                      className="search float-left"
                    >
                      <a _ngcontent-ng-c3537561944="">
                        <i
                          _ngcontent-ng-c3537561944=""
                          id="searchiconDesktopID"
                          className="fas fa-search-plus"
                        />
                      </a>
                    </li>
                  </ul>
                  <div
                    _ngcontent-ng-c3537561944=""
                    className="Myaccount-after-login"
                  >
                    <div _ngcontent-ng-c3537561944="" className="user-blnc">
                      <div
                        _ngcontent-ng-c3537561944=""
                        className="balance ng-star-inserted"
                        style={{ textAlign: "center" }}
                      >
                        <p
                          _ngcontent-ng-c3537561944=""
                          className="pti-ic"
                          style={{ display: "block" }}
                        >
                          {" "}
                          Main{" "}
                          <strong _ngcontent-ng-c3537561944="">
                            PTI{" "}
                            <span
                              _ngcontent-ng-c3537561944=""
                              className="userTotalBalance"
                            >
                              {userData?.balance + userData?.liability}
                            </span>
                          </strong>
                        </p>
                        <p
                          _ngcontent-ng-c3537561944=""
                          className="exp-topcount"
                        >
                          Exposure{" "}
                          <a
                            _ngcontent-ng-c3537561944=""
                            data-bs-toggle="modal"
                            data-bs-target="#exposureModalss"
                            className="mouse-pointer"
                          >
                            <strong _ngcontent-ng-c3537561944="">
                              (
                              <span
                                _ngcontent-ng-c3537561944=""
                                className="exp-red userTotalExposure"
                              >
                                {userData?.liability}
                              </span>
                              ){" "}
                            </strong>
                          </a>
                        </p>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c3537561944=""
                      className="login-refresh-MAcnt-btn"
                    >
                      <span
                        _ngcontent-ng-c3537561944=""
                        className="head-refresh"
                      >
                        <a
                          _ngcontent-ng-c3537561944=""
                          id="menuRefresh"
                          onClick={() => {
                            setBalanceLoad(true);
                            getUserData();
                            setBalanceLoad(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            _ngcontent-ng-c3537561944=""
                            className="fas fa-undo-alt"
                          />
                        </a>
                      </span>
                    </div>
                    <div
                      _ngcontent-ng-c3537561944=""
                      placement="bottom right"
                      className="myaccnt hidden-xs"
                    >
                      <a
                        _ngcontent-ng-c3537561944=""
                        aria-haspopup="true"
                        data-bs-toggle="dropdown"
                        id="accountPopup"
                        role="button"
                        aria-expanded="false"
                        className="nav-link My-acc-font"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          _ngcontent-ng-c3537561944=""
                          className="fas fa-user"
                        />
                        My Account
                        <i
                          _ngcontent-ng-c3537561944=""
                          className="fas fa-sort-down"
                          style={{ position: "relative", top: "-2px" }}
                        />
                      </a>
                      <ul
                        _ngcontent-ng-c3537561944=""
                        className="dropdown-menu align"
                      >
                        <li _ngcontent-ng-c3537561944="">
                          <div
                            _ngcontent-ng-c3537561944=""
                            className="dropdown-header text-left"
                          >
                            <strong _ngcontent-ng-c3537561944="">
                              exchange
                            </strong>
                          </div>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/myprofile"
                            className="dropdown-item"
                            href="/myprofile"
                          >
                            My Profile
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/rolling-commission"
                            className="dropdown-item"
                            href="/rolling-commission"
                          >
                            Rolling Commission
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/account-statement"
                            className="dropdown-item"
                            href="/account-statement"
                          >
                            Account Statement
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/bet-history"
                            className="dropdown-item"
                            href="/bet-history"
                          >
                            Bets History
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/profit-loss"
                            className="dropdown-item"
                            href="/profit-loss"
                          >
                            Profit &amp; Loss
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/password-history"
                            className="dropdown-item"
                            href="/password-history"
                          >
                            Password History
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            routerlink="/activity-log"
                            className="dropdown-item"
                            href="/activity-log"
                          >
                            Activity Log
                          </a>
                          <a
                            _ngcontent-ng-c3537561944=""
                            className="dropdown-item drp-logout"
                          >
                            <button
                              onClick={logout}
                              _ngcontent-ng-c3537561944=""
                              className="btn btn-primary logout-btn"
                            >
                              LOGOUT{" "}
                              <i
                                _ngcontent-ng-c3537561944=""
                                aria-hidden="true"
                                className="fa fa-sign-out-alt"
                              />
                            </button>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div _ngcontent-ng-c3537561944="" className="before-login-items">
                <div
                  _ngcontent-ng-c3537561944=""
                  className="site-logo-con"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    _ngcontent-ng-c3537561944=""
                    alt=""
                    href="/"
                    className="site-logo ng-star-inserted"
                    style={{ cursor: "pointer" }}
                    src="/assets/images/logo.png"
                  />
                </div>
                <div
                  _ngcontent-ng-c3537561944=""
                  className="login-signup-uname-pass"
                >
                  <ul
                    _ngcontent-ng-c3537561944=""
                    className="desktopviewButton hideDekstop showDekstop"
                    style={{ position: "relative" }}
                  >
                    <li _ngcontent-ng-c3537561944=""></li>
                    <li
                      _ngcontent-ng-c3537561944=""
                      className="search float-left"
                    >
                      <a _ngcontent-ng-c3537561944="">
                        <i
                          _ngcontent-ng-c3537561944=""
                          id="searchiconDesktopID"
                          className="fas fa-search-plus"
                        />
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c3537561944=""
                      className="float-left account"
                    >
                      <div _ngcontent-ng-c3537561944="" className="d-flex">
                        <div
                          _ngcontent-ng-c3537561944=""
                          className="form-group mb-0"
                        >
                          <input
                            _ngcontent-ng-c3537561944=""
                            name="usernameForLogin"
                            type="text"
                            placeholder="Username"
                            onChange={(e) => setUsername(e.target.value)}
                            className="form-control uname ng-untouched ng-pristine ng-valid"
                          />
                        </div>
                        <div
                          _ngcontent-ng-c3537561944=""
                          className="form-group mb-0 margin-setting"
                        >
                          <input
                            _ngcontent-ng-c3537561944=""
                            name="passForLogin"
                            type="password"
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            placeholder="Passwrod"
                            className="form-control pass ng-untouched ng-pristine ng-valid"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div _ngcontent-ng-c3537561944="" className="login-signup">
                    <button
                      onClick={() => login(userName, password)}
                      _ngcontent-ng-c3537561944=""
                      className="btn login me-1 222"
                    >
                      <b
                        _ngcontent-ng-c3537561944=""
                        style={{ width: 33, height: 18 }}
                      >
                        {" "}
                        Login{" "}
                      </b>
                      <i
                        _ngcontent-ng-c3537561944=""
                        className="fa fa-sign-in"
                      />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            _ngcontent-ng-c3537561944=""
            className="hideMobile"
            _nghost-ng-c2224168918=""
          >
            <div _ngcontent-ng-c2224168918="" className="menu-wrap">
              <div _ngcontent-ng-c2224168918="" className="full-wrap">
                <ul _ngcontent-ng-c2224168918="" className="tab-menu pull-left">
                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="navbar-item active"
                      href="/"
                    >
                      Home
                    </a>
                  </li>
                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlink="/inplay"
                      className="navbar-item"
                      href="/inplay"
                    >
                      In-Play
                    </a>
                  </li>
                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlink="multimarket"
                      className="navbar-item"
                      href="/multimarket"
                    >
                      Multi Markets
                    </a>
                  </li>

                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/4"
                    >
                      {" "}
                      Cricket
                    </a>
                  </li>
                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/2"
                    >
                      {" "}
                      Tennis
                    </a>
                  </li>
                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/1"
                    >
                      {" "}
                      Soccer
                    </a>
                  </li>
                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/7"
                    >
                      {" "}
                      Horse Racing
                    </a>
                  </li>
                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/7"
                    >
                      {" "}
                      GreyHound Racing
                    </a>
                  </li>
                  <li
                    _ngcontent-ng-c2224168918=""
                    className="ver-menu ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="Virtual navbar-item"
                      href="/allsport-highlight/66104"
                    >
                      {" "}
                      Lottery
                    </a>
                  </li>

                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="navbar-item"
                      href="/allsport-highlight/0"
                    >
                      {" "}
                      Live Casino
                    </a>
                  </li>

                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      className="navbar-item"
                      href="/allsport-highlight/5"
                    >
                      {" "}
                      Virtual Sports
                    </a>
                  </li>

                  <li _ngcontent-ng-c2224168918="" className="ver-menu">
                    <a
                      _ngcontent-ng-c2224168918=""
                      routerlinkactive="active"
                      href="/allsport-highlight/6"
                      className="navbar-item"
                    >
                      {" "}
                      Tips &amp; Previews
                    </a>
                  </li>
                </ul>
                <ul
                  _ngcontent-ng-c2224168918=""
                  className="tab-menu pull-right"
                />
                {userData?.token && (
                  <div _ngcontent-ng-c2224168918="" className="settings">
                    <a
                      _ngcontent-ng-c2224168918=""
                      href="/settings"
                      routerlink="settings"
                    >
                      Setting
                    </a>
                    <i
                      _ngcontent-ng-c2224168918=""
                      className="fa fa-cog ms-1"
                    />
                  </div>
                )}
              </div>
            </div>
            <br _ngcontent-ng-c2224168918="" />
            <br _ngcontent-ng-c2224168918="" />
          </div>
          <div
            _ngcontent-ng-c3537561944=""
            id="exposureModalss"
            tabIndex={-1}
            aria-labelledby="exposureModalLabel"
            aria-hidden="true"
            className="modal fade exposureModals"
          >
            <div _ngcontent-ng-c3537561944="" className="modal-dialog modal-md">
              <div _ngcontent-ng-c3537561944="" className="modal-content">
                <div
                  _ngcontent-ng-c3537561944=""
                  className="modal-header exposure-details"
                >
                  <h1
                    _ngcontent-ng-c3537561944=""
                    id="exposureModalLabel"
                    className="modal-title"
                  >
                    Exposure Detail
                  </h1>
                  <button
                    _ngcontent-ng-c3537561944=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    <span _ngcontent-ng-c3537561944="" aria-hidden="true">
                      ×
                    </span>
                  </button>
                </div>
                <div _ngcontent-ng-c3537561944="" className="modal-body">
                  <table
                    _ngcontent-ng-c3537561944=""
                    className="table table-bordered"
                  >
                    <thead _ngcontent-ng-c3537561944="">
                      <tr _ngcontent-ng-c3537561944="" className="theme1font">
                        <th
                          _ngcontent-ng-c3537561944=""
                          className="text-center"
                        >
                          Sport Name
                        </th>
                        <th
                          _ngcontent-ng-c3537561944=""
                          className="text-center"
                          style={{ width: "50%" }}
                        >
                          Event Name
                        </th>
                        <th
                          _ngcontent-ng-c3537561944=""
                          className="text-center"
                        >
                          Market Name
                        </th>
                        <th
                          _ngcontent-ng-c3537561944=""
                          className="text-center"
                        >
                          Trade
                        </th>
                      </tr>
                    </thead>
                    {exposureTable && exposureTable.length > 0 && (
                      <tbody _ngcontent-ng-c3537561944="">
                        {exposureTable?.map((item) => (
                          <tr
                            _ngcontent-ng-c3537561944=""
                            className="exposurebody"
                          >
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.sportName}
                            </td>
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.eventName}
                            </td>
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.marketName}
                            </td>
                            <td
                              _ngcontent-ng-c3537561944=""
                              className="text-center"
                            >
                              {item.trade}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                    {exposureTable && exposureTable.length == 0 && (
                      <tfoot _ngcontent-ng-c3537561944="">
                        <tr
                          _ngcontent-ng-c3537561944=""
                          className="exposurebody"
                        >
                          <td
                            _ngcontent-ng-c3537561944=""
                            colSpan={4}
                            className="text-center"
                          >
                            No real-time records found
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c3537561944=""
            id="ageconfirmationModalNew"
            tabIndex={-1}
            aria-labelledby="ageconfirmationModalNew"
            aria-hidden="true"
            className="modal fade"
          >
            <div
              _ngcontent-ng-c3537561944=""
              className="modal-dialog modal-dialog-centered"
            >
              <div _ngcontent-ng-c3537561944="" className="modal-content">
                <div
                  _ngcontent-ng-c3537561944=""
                  className="modal-body ageconfirmationModalclass"
                >
                  <div _ngcontent-ng-c3537561944="" className="header-popup">
                    <a
                      _ngcontent-ng-c3537561944=""
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="ui-link"
                    >
                      <i
                        _ngcontent-ng-c3537561944=""
                        className="fas fa-times"
                      />
                    </a>
                  </div>
                  <div
                    _ngcontent-ng-c3537561944=""
                    className="login-panel-container confirm-container"
                  >
                    <div _ngcontent-ng-c3537561944="" className="confirm-text">
                      <div
                        _ngcontent-ng-c3537561944=""
                        className="text1 text-confirm-bold"
                      >
                        Non-Gambling Territories.
                      </div>
                      <hr
                        _ngcontent-ng-c3537561944=""
                        className="confirm-line"
                      />
                      <div _ngcontent-ng-c3537561944="" className="text2">
                        Connecting to our site from non gambling countries, it
                        will be User's responsibility to ensure that their use
                        of the service is lawful.
                      </div>
                    </div>
                    <div _ngcontent-ng-c3537561944="" className="confirm-text">
                      <div
                        _ngcontent-ng-c3537561944=""
                        className="text1 text-confirm-bold"
                      >
                        Underage gambling is prohibited.
                      </div>
                      <hr
                        _ngcontent-ng-c3537561944=""
                        className="confirm-line"
                      />
                      <div _ngcontent-ng-c3537561944="" className="text2">
                        Please confirm if you are{" "}
                        <span _ngcontent-ng-c3537561944="">
                          18 years old and above
                        </span>{" "}
                        as of today.{" "}
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c3537561944=""
                      className="confirm-button"
                    >
                      <button
                        _ngcontent-ng-c3537561944=""
                        data-bs-dismiss="modal"
                        onClick={() => setLoginOpen(true)}
                        className="btn-verification btn-confirm"
                        tabIndex={0}
                      >
                        <span _ngcontent-ng-c3537561944="">Confirm</span>
                      </button>

                      <button
                        _ngcontent-ng-c3537561944=""
                        data-bs-dismiss="modal"
                        className="btn-verification"
                      >
                        <a
                          _ngcontent-ng-c3537561944=""
                          style={{ textDecoration: "none" }}
                        >
                          <span _ngcontent-ng-c3537561944="">Exit</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}
